import { WebStorageStateStore } from "oidc-client-ts";

export interface AppConfig {
  portalUrl: string;
  apiAuthority: string;
  apiClientId: string;
  apiUrl: string;
  licenseMui: string;
}

const config: AppConfig = {
  portalUrl: import.meta.env.VITE_PORTAL_URL || "",
  apiAuthority: import.meta.env.VITE_MSAL_AUTHORITY || "",
  apiClientId: import.meta.env.VITE_MSAL_CLIENT_ID || "",
  apiUrl: import.meta.env.VITE_API_URL || "",
  licenseMui: import.meta.env.LICENSE_MUI || "",
};

export const oidcConfig = {
  authority: import.meta.env.VITE_MSAL_AUTHORITY,
  client_id: import.meta.env.VITE_MSAL_CLIENT_ID,
  redirect_uri: config.portalUrl,
  post_logout_redirect_uri: config.portalUrl,
  silent_redirect_uri: `${config.portalUrl}/silent-renew.html`,
  automaticSilentRenew: true,
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export default config;
